/**
 * Utility functions for consistent error handling across AdvertisingModal components
 */

/**
 * Standardizes error handling across components
 * @param error The error to handle
 * @param onError Optional callback for error handling
 * @param fallbackMessage Fallback message if error is not a string or Error
 * @returns Standardized error message
 */
export const handleError = (
  error: unknown,
  onError?: (error: string) => void,
  fallbackMessage: string = 'An error occurred. Please try again.'
): string => {
  let errorMessage: string

  if (error instanceof Error) {
    errorMessage = error.message
  } else if (typeof error === 'string') {
    errorMessage = error
  } else {
    errorMessage = fallbackMessage
  }

  // Call the error callback if provided
  if (onError) {
    onError(errorMessage)
  }

  return errorMessage
}

/**
 * Safe localStorage operations with error handling
 */
export const safeLocalStorage = {
  getItem: (key: string): string | null => {
    try {
      return localStorage.getItem(key)
    } catch {
      return null
    }
  },

  setItem: (key: string, value: string): boolean => {
    try {
      localStorage.setItem(key, value)
      return true
    } catch {
      return false
    }
  },

  removeItem: (key: string): boolean => {
    try {
      localStorage.removeItem(key)
      return true
    } catch {
      return false
    }
  },
}
